import type {GridFilterOperator} from '@mui/x-data-grid'
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  getGridStringOperators,
  GridFilterInputValue,
} from '@mui/x-data-grid'

export const CustomToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  )
}

export type Lookup = 'icontains' | 'iexact' | 'istartswith' | 'iendswith' | 'in'

export const operatorToLookup: Record<string, Lookup | undefined> = {
  contains: 'icontains',
  doesNotContain: 'icontains',
  equals: 'iexact',
  startsWith: 'istartswith',
  endsWith: 'iendswith',
  isAnyOf: 'in',
}

export const doesNotContainOperator: GridFilterOperator = {
  label: 'does not contain',
  value: 'doesNotContain',
  requiresFilterValue: true,
  InputComponent: GridFilterInputValue,
  getApplyFilterFn: (item) => {
    const raw = item?.value ?? ''
    const needle = String(raw).toLowerCase().trim()
    if (!needle) {
      return null
    }
    return (params) =>
      !String(params.value ?? '')
        .toLowerCase()
        .includes(needle)
  },
}

export const baseStringOperators = getGridStringOperators().filter((op) => op.value !== 'isAnyOf')

const containsIndex = baseStringOperators.findIndex((op) => op.value === 'contains')

export const customStringOperators = [
  ...baseStringOperators.slice(0, containsIndex + 1),
  doesNotContainOperator,
  ...baseStringOperators.slice(containsIndex + 1),
]
